import { DEFAULT_COLORS } from './constants.js';
import { compactArray } from '../arrays.js';

export function showEmptyState(wrapper, statusChip) {
  setStatus(statusChip, 'Diagram unavailable', true);

  if (wrapper.querySelector('[data-diagram-empty-state]')) return;

  const emptyState = document.createElement('div');
  emptyState.dataset.diagramEmptyState = 'true';
  emptyState.className = 'absolute inset-0 flex items-center justify-center px-6 text-center text-sm text-slate-500';
  emptyState.textContent = 'Diagram details are unavailable for this page.';
  wrapper.appendChild(emptyState);
}

export function updateOverlay({ canvas, overlay, overlayTitle, overlayDesc, overlayTag, event, node, selected = false }) {
  if (!overlay) return;

  if (!node) {
    overlay.classList.add('hidden');
    return;
  }

  const rect = canvas.getBoundingClientRect();
  const overlayWidth = overlay.offsetWidth || 260;
  const overlayHeight = overlay.offsetHeight || 150;
  const left = Math.min(Math.max(event.clientX - rect.left + 20, 12), Math.max(rect.width - overlayWidth - 12, 12));
  const top = Math.min(Math.max(event.clientY - rect.top + 20, 12), Math.max(rect.height - overlayHeight - 12, 12));

  if (overlayTitle) overlayTitle.textContent = node.label;
  if (overlayDesc) overlayDesc.textContent = selected ? selectedNodeDescription(node) : hoverNodeDescription(node);
  if (overlayTag) {
    overlayTag.textContent = node.phase || 'Phase';
    overlayTag.style.color = node.color || DEFAULT_COLORS.brand400;
  }
  overlay.classList.remove('hidden');
  overlay.style.left = `${left}px`;
  overlay.style.top = `${top}px`;
}

export function setStatus(statusChip, label, active) {
  if (!statusChip) return;

  statusChip.textContent = label;
  statusChip.classList.toggle('border-brand-900', active);
  statusChip.classList.toggle('text-brand-900', active);
}

export function getCanvasContext(canvas) {
  try {
    return canvas.getContext?.('2d');
  } catch {
    return null;
  }
}

function selectedNodeDescription(node) {
  return compactArray([
    node.detail,
    node.operatorTip ? `Operator tip: ${node.operatorTip}` : null,
    node.desc
  ]).join(' ');
}

function hoverNodeDescription(node) {
  return node.desc || node.detail || '';
}
